<template>
  <div :class="{ loading: loading }">
    <div class="create-button" @click="openCreateModal">
      <button class="btn btn-primary">{{ lang.company_groups_create }}</button>
    </div>
    <v-app>
      <v-content>
        <v-data-table
          :headers="computedHeaders"
          :items="data"
          item-key="name"
          ref="table"
          hide-actions
          v-if="renderComponent"
          :disableInitialSort="true"
          :loading="loading"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td
                v-for="header in computedHeaders"
                :data-id="props.item.id"
                :key="header.value"
                class="text-center"
                @click="openEditModal(props.item)"
              >
                <span v-if="header.value !== 'companies'">
                  {{ props.item[header.value] }}
                </span>
                <span v-else>{{
                  companyArrayToString(props.item[header.value])
                }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-content>
    </v-app>
    <CreateGroupModal :lang="lang" @fetchData="getGroups"></CreateGroupModal>
    <EditGroupModal :lang="lang" @fetchData="getGroups"></EditGroupModal>
    <DeleteGroupModal :lang="lang" @fetchData="getGroups"></DeleteGroupModal>
  </div>
</template>

<script>
import DeleteGroupModal from "./DeleteGroupModal.vue";
import EditGroupModal from "./EditGroupModal.vue";
import axios from "axios";
import CreateGroupModal from "./CreateGroupModal.vue";
export default {
  props: {
    headers: {
      type: Object,
      required: true,
    },
    lang: {
      type: Object,
      required: true,
    },
  },
  components: {
    CreateGroupModal,
    EditGroupModal,
    DeleteGroupModal,
  },
  directives: {},
  computed: {
    computedHeaders() {
      let headers = [];

      Object.keys(this.headers).forEach((header) => {
        let headerObject = {
          value: header,
          text: this.headers[header],
          width: header == "id" ? "100px" : null,
        };

        headers.push(headerObject);
      });
      return headers;
    },
  },
  data() {
    return {
      renderComponent: false,
      loading: true,
      search: "",
      data: [],
    };
  },
  created() {
    this.getGroups();
  },
  methods: {
    openEditModal(group) {
      this.$eventBus.$emit("openEditModal", group);
    },
    openCreateModal() {
      this.$eventBus.$emit("openCreateModal");
    },
    getGroups() {
      axios.get("/companies/groups/index").then((response) => {
        let data = response.data;
        this.data = data;
        this.loading = false;
        this.renderComponent = true;
      });
    },
    companyArrayToString(companies) {
      if (!companies.length || companies.length === 0) {
        return "";
      }

      let companyNames = [];
      companies.forEach((company) => {
        companyNames.push(company.name);
      });
      let companiesString = companyNames.join(", ");

      return companiesString.length > 150
        ? companiesString.slice(0, 147) + "..."
        : companiesString;
    },
  },
};
</script>


<style lang="scss" scoped>
.create-button {
  margin-bottom: 0.6rem;
  display: flex;
  justify-content: flex-start;
  button.btn {
    font-size: unset !important;
  }
}

.v-datatable-root table.v-table.fixed-columns-table {
  table-layout: unset;
}

.v-datatable-root {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  tr {
    border: none !important;
  }

  .theme--light.v-table thead tr:first-child {
    border-bottom: none !important;
  }

  td {
    border: none;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    cursor: pointer;
  }

  th {
    text-align: center !important;
    border-right: 1px solid rgba(0, 0, 0, 0.12);
  }

  th:first-of-type,
  td:first-of-type {
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }

  tbody {
    border-right: 1px solid rgba(0, 0, 0, 0.12);
  }

  tbody tr:last-of-type {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  }

  @media (min-width: 0) {
    .text-xs-left {
      text-align: center !important;
    }
  }

  table.v-table tbody td,
  .v-datatable-root table.v-table tbody th {
    height: 53px;
  }

  .v-select__slot {
    height: 40px;
  }

  .filter-header {
    height: 53px !important;
  }

  tbody tr:nth-child(2n) {
    background-color: #eee;

    .fixed-column {
      background-color: #eee !important;
    }
  }
}

.d-flex {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 25px;

  .bmd-form-group {
    padding-top: 0;
    display: block;
    width: max-content;
  }

  .btn {
    position: relative;
    z-index: 10;
    font-size: 14px !important;
    margin-bottom: 0 !important;
    border-radius: 0.25rem !important;
    display: block;
    margin-left: auto;
  }
}

input.search-input {
  display: block;
  font-size: 12px;
  width: 400px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  appearance: none;
  padding-bottom: 5px;
  margin: {
    left: 15px;
    top: 25px;
    bottom: 25px;
  }
  padding: 12px 0px 10px 12px;
  border-radius: 0.25rem;

  &.focus-visible {
    outline: none;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }

  &:foucs {
    outline: none;
  }
}

.loading {
  opacity: 0.5;
}

.columns-editor-container {
  position: relative;
  z-index: 10;
}
</style>